import { render, staticRenderFns } from "./parameter-select.vue?vue&type=template&id=23898a46&"
import script from "./parameter-select.component.ts?vue&type=script&lang=ts&"
export * from "./parameter-select.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports